import { WGSL_FOG } from '../../shader/wgsl-fog.js';

const PBR_FOG_HELPER = WGSL_FOG;
const PBR_FOG_BLOCK = `if(scene.vFogInfos.x>0.0){var fogFactor=calcFogFactor((scene.view*vec4<f32>(input.worldPos,1.0)).xyz);fogFactor=pow(fogFactor,2.2);color=mix(pow(scene.vFogColor.rgb,vec3<f32>(2.2)),color,fogFactor);}`;

export { PBR_FOG_BLOCK, PBR_FOG_HELPER };
//# sourceMappingURL=pbr-fog-wgsl.js.map
